import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionsSortable } from '../../../questiontype/Sortable/registry/ConditionsSortable';
import { ConditionRegistryAssociate } from '../../../questiontype/Associate/registry/ConditionRegistryAssociate';
import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionsMemorizePoints } from '../../../questiontype/MemorizePoints/registry/ConditionsMemorizePoints';
import { RareConditionsBrowser } from './RareConditionsBrowser';
import { ConditionsKnowAWord } from '../../../questiontype/KnowAWord/registry/ConditionsKnowAWord';
export class RareConditions extends ConditionRegistryCategory {
    label = 'Rare';
    c_sortable = new ConditionsSortable(this);
    c_associate = new ConditionRegistryAssociate(this);
    c_memorizepoints = new ConditionsMemorizePoints(this);
    c_browser = new RareConditionsBrowser(this);
    c_k = new ConditionsKnowAWord(this);
    constructor(parent) {
        super(parent);
        super.init();
    }
    aspect_isDraggableDragging = () => new ConditionRegistryItem({
        parent: this,
        label: 'Wird der Aspect gerade Gedragggt',
        eval: ({ aspect }) => {
            return aspect.aspectDraggable.isDragging;
        },
    });
}
